module.exports = __webpack_public_path__ + "img/h2.6b721806.png";